export default __webpack_public_path__ + "static/media/id-card.2630c9f6.png";